/**
 * "Merlin will check back on Oct 6: …" on an item's workspace (kanban
 * 43160d8b, build step 3): the follow-ups Merlin promised on THIS item, so
 * the brief says what is still coming without a trip to the Pending tab.
 * Open promises only; what Merlin already found is in the thread's
 * conversation (the follow-up note) and on the Pending tab.
 */
import { Link } from 'react-router-dom';
import type { MerlinFollowupRead } from '../../services/merlinFollowups';
import { inlinePromiseLine, isOpenFollowup } from './pendingView';
import styles from './QualityWorkspace.module.css';

export function PendingFollowupsLine({
  followups,
  pendingPath = '../pending',
}: {
  /** The follow-ups on this item (pendingView.followupsForThread). */
  followups: MerlinFollowupRead[];
  /** Where "Pending" links to, from the workspace route. */
  pendingPath?: string;
}) {
  const open = followups.filter(isOpenFollowup);
  if (open.length === 0) return null;
  return (
    <div className={styles.pendingLine} role="status" data-testid="pending-followups-line">
      <ul className={styles.pendingList}>
        {open.map((row) => (
          <li key={row.id} data-testid="pending-followup" data-status={row.status}>
            ⏳ {inlinePromiseLine(row)}
          </li>
        ))}
      </ul>
      <Link to={pendingPath} className={styles.pendingLink} data-action="qcp_pending_from_item">
        Pending →
      </Link>
    </div>
  );
}
